/**
 * Side-effect entry: import this module first from index.js so the Browser
 * agent starts before React. (ESM hoists all imports, so calling init between
 * import lines in index.js is unreliable.)
 */
import { initNewRelicBrowser } from './newrelicBrowser';

initNewRelicBrowser();
